(function () {
  "use strict";

  function fire(el) {
    if (!el) return;
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function initMadeoNotch(root) {
    (root || document).querySelectorAll("[data-madeo-notch]").forEach((wrap) => {
      if (wrap.dataset.madeoInited === "1") return;
      wrap.dataset.madeoInited = "1";

      const out = wrap.querySelector("[data-madeo-selection]");
      const prop = wrap.querySelector("[data-madeo-cart-prop]");
      const btns = Array.from(wrap.querySelectorAll(".madeo-hot"));

      function selected() {
        return btns
          .filter((b) => b.classList.contains("is-active"))
          .map((b) => b.dataset.side);
      }

      function sync() {
        const sel = selected();
        const value = sel.join(", ");

        wrap.classList.toggle("has-left", sel.includes("Linke Seite"));
        wrap.classList.toggle("has-right", sel.includes("Rechte Seite"));

        if (out) out.textContent = value;

        // WICHTIG: in Shopify property schreiben (Warenkorb)
        if (prop) {
          prop.value = value;
          fire(prop);
        }
      }

      wrap.addEventListener("click", (e) => {
        const btn = e.target.closest(".madeo-hot");
        if (!btn) return;
        btn.classList.toggle("is-active");
        sync();
      });

      sync();
    });
  }

  // init
  initMadeoNotch(document);

  // Live Product Options / Theme lädt oft nach
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        initMadeoNotch(document);
        break;
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
